// SAP integration removed — stub to prevent downstream breakage
export default {
  namespaced: true,
  state: () => ({}),
  getters: {
    isSapIntegrated: () => false,
    sapDebtorsMap: () => new Map(),
    sapItemsMap: () => new Map(),
  },
  mutations: {},
  actions: {
    fetchSapApiKey() { return Promise.resolve(null) },
    fetchAdapterDebtorsIfNeeded() { return Promise.resolve([]) },
    fetchAdapterDebtors() { return Promise.resolve([]) },
    fetchAdapterItems() { return Promise.resolve([]) },
    fetchAdapterItemsIfNeeded() { return Promise.resolve([]) },
  },
};